import { AuthLayout } from '@/design-system/layouts'
import { ForgotPassword } from '../components'

export function ForgotPasswordPage() {
  return (
    <AuthLayout>
      <ForgotPassword />
    </AuthLayout>
  )
}
